import { createSlice } from '@reduxjs/toolkit';
import { IntegrationDetailStateType } from '../../types/integration';

const initialState: IntegrationDetailStateType = {
    shoptetStatuses: null,
    shoptetStatusesLoading: false,
    shoptetShippingMethods: null,
    shoptetShippingMethodsLoading: false,
    shoptetPaymentMethods: null,
    shoptetPaymentMethodsLoading: false,
    shopifyPaymentMethods: null,
    shopifyPaymentMethodsLoading: false,
    error: false,
    saveLoading: false,
    shopifyShippingMethods: null,
    shopifyShippingMethodsLoading: false,
    woocommercePaymentMethods: null,
    woocommercePaymentMethodsLoading: false,
    woocommerceShippingMethods: null,
    woocommerceShippingMethodsLoading: false
};
export const integrationDetailSlice = createSlice({
    name: 'integrationDetail',
    initialState,
    reducers: {
        getShoptetStatusesFetch: (state, action) => {
            state.shoptetStatusesLoading = true;
            state.error = false;
        },
        getShoptetStatusesFetchSuccess: (state, action) => {
            state.shoptetStatuses = action.payload;
            state.shoptetStatusesLoading = false;
        },
        getShoptetStatusesFetchFailure: (state, action) => {
            state.shoptetStatuses = null;
            state.shoptetStatusesLoading = false;
            state.error = true;
        },
        getShoptetShippingMethodsFetch: (state, action) => {
            state.shoptetShippingMethodsLoading = true;
            state.error = false;
        },
        getShoptetShippingMethodsFetchSuccess: (state, action) => {
            state.shoptetShippingMethods = action.payload;
            state.shoptetShippingMethodsLoading = false;
        },
        getShoptetShippingMethodsFetchFailure: (state, action) => {
            state.shoptetShippingMethods = null;
            state.shoptetShippingMethodsLoading = false;
            state.error = true;
        },
        getShoptetPaymentMethodsFetch: (state, action) => {
            state.shoptetPaymentMethodsLoading = true;
            state.error = false;
        },
        getShoptetPaymentMethodsFetchSuccess: (state, action) => {
            state.shoptetPaymentMethods = action.payload;
            state.shoptetPaymentMethodsLoading = false;
        },
        getShoptetPaymentMethodsFetchFailure: (state, action) => {
            state.shoptetPaymentMethods = null;
            state.shoptetPaymentMethodsLoading = false;
            state.error = true;
        },
        getShopifyPaymentMethodsFetch: (state, action) => {
            state.shopifyPaymentMethodsLoading = true;
            state.error = false;
        },
        getShopifyPaymentMethodsFetchSuccess: (state, action) => {
            state.shopifyPaymentMethods = action.payload;
            state.shopifyPaymentMethodsLoading = false;
        },
        getShopifyPaymentMethodsFetchFailure: (state, action) => {
            state.shopifyPaymentMethods = null;
            state.shopifyPaymentMethodsLoading = false;
            state.error = true;
        },
        getShopifyShippingMethodsFetch: (state, action) => {
            state.shopifyShippingMethodsLoading = true;
            state.error = false;
        },
        getShopifyShippingMethodsFetchSuccess: (state, action) => {
            state.shopifyShippingMethods = action.payload;
            state.shopifyShippingMethodsLoading = false;
        },
        getShopifyShippingMethodsFetchFailure: (state, action) => {
            state.shopifyShippingMethods = null;
            state.shopifyShippingMethodsLoading = false;
            state.error = true;
        },
        getWoocommercePaymentMethodsFetch: (state, action) => {
            state.woocommercePaymentMethodsLoading = true;
            state.error = false;
        },
        getWoocommercePaymentMethodsFetchSuccess: (state, action) => {
            state.woocommercePaymentMethods = action.payload;
            state.woocommercePaymentMethodsLoading = false;
        },
        getWoocommercePaymentMethodsFetchFailure: (state, action) => {
            state.woocommercePaymentMethods = null;
            state.woocommercePaymentMethodsLoading = false;
            state.error = true;
        },
        getWoocommerceShippingMethodsFetch: (state, action) => {
            state.woocommerceShippingMethodsLoading = true;
            state.error = false;
        },
        getWoocommerceShippingMethodsFetchSuccess: (state, action) => {
            state.woocommerceShippingMethods = action.payload;
            state.woocommerceShippingMethodsLoading = false;
        },
        getWoocommerceShippingMethodsFetchFailure: (state, action) => {
            state.woocommerceShippingMethods = null;
            state.woocommerceShippingMethodsLoading = false;
            state.error = true;
        },
        saveSkladonMappingFetch: (state, action) => {
            state.error = false;
            state.saveLoading = true;
        },
        saveSkladonMappingFetchSuccess: {
            reducer: (state) => {
                state.error = false;
                state.saveLoading = false;
            },
            prepare: (payload?: { messageSuccess?: { title: string; text?: string } }) => ({
                payload: payload ?? {}
            })
        },
        saveSkladonMappingFetchFailure: (state) => {
            state.error = true;
            state.saveLoading = false;
        },
        saveSkladonMappingFetchStart: (state) => {
            state.saveLoading = true;
        },

        clearApplicationInstall: () => initialState
    }
});

export const {
    getShoptetStatusesFetch,
    getShoptetStatusesFetchSuccess,
    getShoptetStatusesFetchFailure,
    getShoptetShippingMethodsFetch,
    getShoptetShippingMethodsFetchSuccess,
    getShoptetShippingMethodsFetchFailure,
    getShoptetPaymentMethodsFetch,
    getShoptetPaymentMethodsFetchSuccess,
    getShoptetPaymentMethodsFetchFailure,
    saveSkladonMappingFetch,
    saveSkladonMappingFetchSuccess,
    saveSkladonMappingFetchFailure,
    saveSkladonMappingFetchStart,
    getShopifyPaymentMethodsFetch,
    getShopifyPaymentMethodsFetchSuccess,
    getShopifyPaymentMethodsFetchFailure,
    getShopifyShippingMethodsFetch,
    getShopifyShippingMethodsFetchSuccess,
    getShopifyShippingMethodsFetchFailure,
    getWoocommercePaymentMethodsFetch,
    getWoocommercePaymentMethodsFetchSuccess,
    getWoocommercePaymentMethodsFetchFailure,
    getWoocommerceShippingMethodsFetch,
    getWoocommerceShippingMethodsFetchSuccess,
    getWoocommerceShippingMethodsFetchFailure,
} = integrationDetailSlice.actions;

export default integrationDetailSlice.reducer;
